<h2 mat-dialog-title class="dialog-title">
  <mat-icon>analytics</mat-icon>
  <span>Reference Range Suggestions</span>
</h2>

<mat-dialog-content class="dialog-content" aria-live="polite">
  <div class="observation-banner">
    <div class="banner-block">
      <div class="label">Observation</div>
      <div class="value">{{ observationDisplay() }}</div>
      @if(observationCode()) {
        <div class="code-ref">{{ observationCode() }}</div>
      }
    </div>
    <div class="banner-block">
      <div class="label">Current Result</div>
      <div class="value result">{{ (observation | valueToString) || '—' }}</div>
    </div>
  </div>

  @if(loading) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }

  @if(!loading && suggestions.length === 0) {
    <div class="empty-state">
      <p>No saved reference range templates matched this observation.</p>
      <p class="muted">Create one from the Reference Range workspace, then try again.</p>
      <button mat-stroked-button color="primary" routerLink="/app/observation-reference-ranges" (click)="close()">
        <mat-icon>open_in_new</mat-icon>
        <span>Manage Templates</span>
      </button>
    </div>
  } @else if (suggestions.length > 0) {
    <div class="table-wrapper">
      <table mat-table [dataSource]="suggestions" class="mat-elevation-z2">
        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef>Meaning</th>
          <td mat-cell *matCellDef="let template">
            {{ template.range?.type?.text || template.range?.type?.coding?.[0]?.display || template.display }}
          </td>
        </ng-container>

        <ng-container matColumnDef="range">
          <th mat-header-cell *matHeaderCellDef>Range</th>
          <td mat-cell *matCellDef="let template">{{ rangeDescription(template.range) }}</td>
        </ng-container>

        <ng-container matColumnDef="appliesTo">
          <th mat-header-cell *matHeaderCellDef>Applies To</th>
          <td mat-cell *matCellDef="let template">{{ appliesToDescription(template.range) }}</td>
        </ng-container>

        <ng-container matColumnDef="age">
          <th mat-header-cell *matHeaderCellDef>Age</th>
          <td mat-cell *matCellDef="let template">{{ ageDescription(template.range) }}</td>
        </ng-container>

        <ng-container matColumnDef="classification">
          <th mat-header-cell *matHeaderCellDef>Match</th>
          <td mat-cell *matCellDef="let template">
            <mat-chip-set>
              <mat-chip class="classification-chip" [ngClass]="template.classification">
                <mat-icon>{{ classificationIcon(template.classification) }}</mat-icon>
                <span>{{ classificationLabel(template.classification) }}</span>
              </mat-chip>
            </mat-chip-set>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let template">
            <button mat-flat-button color="primary" (click)="applyRange(template)"
              [disabled]="!canApplyRanges() || isTemplateApplying(template)"
              [matTooltip]="canApplyRanges() ? 'Apply this range to the observation' : 'Save the observation first'">
              @if(isTemplateApplying(template)) {
                <mat-icon class="spin">hourglass_top</mat-icon>
                <span>Applying…</span>
              } @else {
                <mat-icon>playlist_add</mat-icon>
                <span>Apply Range</span>
              }
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns; trackBy: trackByTemplate"></tr>
      </table>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Close</button>
  <button mat-stroked-button color="primary" routerLink="/app/observation-reference-ranges" (click)="close()">
    Manage Templates
  </button>
</mat-dialog-actions>
